export default __webpack_public_path__ + "static/MODIFIED SOLID SURFACE - MARVELLA-a0b5f37572fd629e51683785a0693311.webp";